export function smoothScroll(to, from, next, scrollTarget = 0) {
    var p1 = to.matched.find(x => x.name === to.name);
    var p2 = from.matched.find(x => x.name === from.name);
    if (p1 && p1.parent && p1.parent.name && p2 && p2.parent && p2.parent.name && p1.parent.name === p2.parent.name && (!to.query || (!to.query.scrollTop)))
        next();
    else {
        window.onscroll = isAtTop;
        if (window.pageYOffset !== 0)
            window.scrollTo({
                top: scrollTarget,
                behavior: "smooth"
            });
        else
            next();
    }


    function isAtTop() {
        if (window.pageYOffset === scrollTarget) {
            next();
            window.onscroll = undefined;
        }
    }
}

export function smoothLeave(el) {
    document.body.style.overflowX = "hidden";
    el.parentElement.style.transition = "height 500ms ease-in-out";
    el.parentElement.style.height = el.offsetHeight + "px";
}

export function smoothEnter(el) {
    document.body.style.overflowX = "hidden";
    el.parentElement.style.transition = "height 500ms ease-in-out";
    el.parentElement.style.height = el.offsetHeight + "px";
}

export function smoothAfterEnter(el) {
    document.body.style.overflowX = "";
    el.parentElement.style.transition = "";
    el.parentElement.style.height = "";
}

export const enterCancelled = smoothAfterEnter;
export const leaveCancelled = smoothAfterEnter;